import React from "react";

const cardsData = [
  {
    id: "01",
    title: "House and\nFleet Accounts",
    description:
      "Easily recognize and process corporate or registered users through integrated License Plate Recognition (LPR) or RFID access. Enable automated redemptions, account-based discounts.",
    bg: "#1F3A70",
  },
  {
    id: "02",
    title: "Monthly\nMembership",
    description:
      "Quickly sell, redeem and renew membership plans directly from the Pay Station. Add License Plate Recognition (LPR) to eliminate RFID tags, increase conversions, and reduce labor.",
    bg: "#3F5871",
  },
  {
    id: "03",
    title: "Gift Cards\n& Wash Cards",
    description:
      "Conveniently sell, recharge and dispense cards directly from the Pay Station. After purchasing the card, it is programmed, dispensed, and ready for use.",
    bg: "#3F5871",
  },
  {
    id: "04",
    title: "Built-in Security",
    description:
      "The kiosk's stainless steel enclosure is engineered for durability in high-traffic or unattended environments. It resists vandalism, weather impact, and tampering — keeping internal components safe.",
    bg: "#1F3A70",
  },
];

export const CardsSec3 = () => {
  return (
    <section id="cards-sec3" className="py-20 px-6 lg:px-8 bg-white">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#111827] mb-14 leading-tight">
          Built to Perform. Configured <br className="hidden sm:block" /> to
          Fit. Ready to Deploy.
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {cardsData.map((item) => (
            <div
              key={item.id}
              className="relative text-white rounded-2xl overflow-hidden w-full max-w-[630px] mx-auto h-[420px] sm:h-[479px] flex"
              style={{ backgroundColor: item.bg }}
            >
              <div className="relative z-10 flex flex-col p-5 sm:p-8 w-[55%] sm:w-[80%]">
                <p className="text-[32px] sm:text-[64px] font-bold opacity-40 leading-none">
                  {item.id}
                </p>
                <h3 className="text-lg sm:text-3xl font-bold leading-snug mt-2 whitespace-pre-line">
                  {item.title}
                </h3>
                <p className="text-xs sm:text-[17px] text-white/80 leading-relaxed mt-6 sm:mt-10">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};